import { ActionEventProps, ActionEvents, AppOpenSources } from '@griply/types';
import { FirstOpenStorage, recordFirstOpen } from '@griply/utils';
import { useEffect } from 'react';

export type TrackAppFirstOpen = (
  event: ActionEvents.AppFirstOpen,
  props: ActionEventProps[ActionEvents.AppFirstOpen],
) => void;

export type UseTrackAppFirstOpenOptions = {
  // Firebase Auth session presence (never the user document); undefined until the SDK restored it.
  isLoggedIn: boolean | undefined;
  storage: FirstOpenStorage;
  resolveSource: () => Promise<AppOpenSources>;
  track: TrackAppFirstOpen;
};

// The record is written before the first await, so a re-run reads it back as already recorded.
export const trackAppFirstOpenOnce = async ({
  isLoggedIn,
  storage,
  resolveSource,
  track,
}: UseTrackAppFirstOpenOptions): Promise<void> => {
  if (isLoggedIn === undefined) {
    return;
  }
  const { isNew } = recordFirstOpen(storage, isLoggedIn);
  if (!isNew) {
    return;
  }
  const source = await resolveSource();
  track(ActionEvents.AppFirstOpen, { source, is_logged_in: isLoggedIn });
};

export const useTrackAppFirstOpen = (options: UseTrackAppFirstOpenOptions) => {
  const { isLoggedIn, storage, resolveSource, track } = options;

  useEffect(() => {
    trackAppFirstOpenOnce({ isLoggedIn, storage, resolveSource, track });
  }, [isLoggedIn, storage, resolveSource, track]);
};
